<template>
    <div class="order-component">
        <el-table max-height="650" :data="categoryData" style="width: 100%" border size="mini" :header-cell-style="{
            background: '#ecf4ff',
            color: '#333',
            fontWeight: '900',
            fontSize: '0.28rem'
        }" id="forStyle">
            <!-- <el-table-column type="expand">
          <template slot-scope="scope">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="录入人">
                <span>{{ scope.row.typeiner_name ? scope.row.typeiner_name: '' }}</span>
              </el-form-item>
              <el-form-item label="应聘者简历">
                <el-image
                  v-if="scope.row.biographical_url && scope.row.biographical_url.image_info.is_img"
                  style="width: 200px; height: 200px"
                  :src="scope.row.biographical_url ? scope.row.biographical_url.image_info.url : ''"
                  :preview-src-list="scope.row.biographical_url ? [scope.row.biographical_url.image_info.url] : []">
                </el-image>
                <el-tooltip v-else class="item" effect="dark"
                  :content="scope.row.biographical_url ? scope.row.biographical_url.image_info.name : '' "
                  placement="top">
                  <el-link type="primary" style="cursor:pointer"
                    :href="scope.row.biographical_url ? scope.row.biographical_url.image_info.url : ''"
                    target="_blank">
                    <span
                      style="width:200px;display:block;text-overflow:ellipsis;white-space:nowrap;overflow:hidden">{{ scope.row.biographical_url ? scope.row.biographical_url.image_info.name : '' }}</span>
                  </el-link>
                </el-tooltip>
              </el-form-item>
            </el-form>
          </template>
</el-table-column> -->
            <el-table-column prop="id" label="订单ID">
            </el-table-column>
            <el-table-column prop="out_trade_no" label="订单号" width="240px">
            </el-table-column>
            <el-table-column prop="total_amount" label="订单金额">
                <template slot-scope="scope">
                    <span v-if="scope.row.total_amount">{{ scope.row.total_amount }}</span>
                    <span v-else>{{ scope.row.total / 100 }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="user_info.nickname" label="用户名" width="150px">
            </el-table-column>
            <el-table-column prop="user_info.phone" label="手机号">
                <template slot-scope="scope">
                    <phone-com v-if="scope.row.user_info" :comPhone="scope.row.user_info.phone" :vagaryPhone="scope.row.user_info.vagary_phone"
                        style="display: inline-block" />
                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="订单创建时间" width="140px">
                <template slot-scope="scope">
                    <span v-if="scope.row.regtime">{{ scope.row.regtime }}</span>
                    <span v-else>{{ scope.row.created_at }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="支付时间" width="140px">
                <template slot-scope="scope">
                    <span v-if="scope.row.send_pay_date">{{ scope.row.send_pay_date }}</span>
                    <span v-else>{{ scope.row.success_time }}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column label="服务时间">
                <template slot-scope="scope">
                    <p>
                        <span>服务开始时间:</span>
                        <span>{{ scope.row.service_started_at }}</span>
                    </p>
                    <p>
                        <span>服务结束时间:</span>
                        <span>{{ scope.row.service_ended_at }}</span>
                    </p>
                </template>
            </el-table-column> -->
            <!-- <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="全部审核通过" placement="top"
              v-if="scope.row.status === 3">
              <el-button @click.native.prevent="editRow(scope.row.id)" type="primary" size="mini"
                icon="el-icon-document-checked" circle disabled>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="全部审核通过" placement="top" v-else>
              <el-button @click.native.prevent="editRow(scope.row.id)" type="primary" size="mini"
                icon="el-icon-document-checked" circle>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="提交反馈" placement="top">
              <el-button @click.native.prevent="openExamineFeed(scope.row.id)" type="warning"
                size="mini" icon="el-icon-finished" circle>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column> -->
        </el-table>
        <div class="block" style="margin-top: 10px; text-align: right">
            <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
                :current-page.sync="npage" layout="sizes, total, prev, pager, next, jumper" :total="total"
                :page-sizes="[10, 15, 30, 50, 100]" :page-size="categoryPerPage" background>
            </el-pagination>
        </div>
    </div>
</template>

<script>
import PhoneCom from "common/PhoneCom";
export default {
    name: 'OrderComponent',
    components: { PhoneCom },
    props: {
        dataTypeOrder: {
            Object
        }
    },
    data() {
        let checkPhone = (rule, value, callback) => {
            if (value !== '') {
                let reg = /^1[3456789]\d{9}$/
                if (!reg.test(value)) {
                    callback(new Error('请输⼊有效的⼿机号码'))
                }
            }
            callback()
        }
        return {
            hyperfHost:
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:9501"
                    : "https://qyh-next-server.zhang66.cn",
            ServiceTimeDrawer: false,
            companyComId: null,
            companyInfoDrawer: false,
            unMatterOveredId: '',
            pageSize_un: 10,
            total_un: 0,
            npage_un: 1,
            unMatterOveredData: [],
            unMatterOveredDrawer: false,
            headers: {
                Authorization: localStorage.getItem('token'),
            },
            change: false,
            aboutExId: '',
            FOptions: [],
            needUrl: [],
            fileList: [],
            limit: 10,
            distributeForm: {
                feedback: '',
                progress: '1',
            },
            examineFeed: {
                remark: '',
            },
            distributeDrawer: false,
            exmined: [],
            examine: [],
            examineId: '',
            examineDialog: false,
            pageSize_inside: 10,
            nowPage_inside: 1,
            total_inside: 0,
            npage_inside: 1,
            examineData: [],
            searchArr: {
                category_id: '',
            },
            npage: 1,
            categoryPerPage: 10,
            total: null,
            listSortForm: [],
            categoryData: [],
            searcher: null,
            categoryEditDrawer: false,
            searchLoading: false,
            searchCategories: [],
            categoryIndrawer: false,
            direction: 'rtl',
            ifDisplay: false,
            ListIfDisplay: [],
            listSort: [],
            category: '',
            branch: [],
            options_adminUsers: [],
            typeInPickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 3600 * 1000 * 24
                },
            },
            categoryForm: {
                name: '',
                phone: '',
                branch_id: '',
                station: '',
                meetAt: '',
                meet_place: '',
                feishuurl: '',
            },
            editCategoryForm: {
                categoryId: '',
                category_name: '',
                display: false,
            },
            rules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                    {
                        min: 1,
                        max: 20,
                        message: '长度在 1 到 20 个字符',
                        trigger: 'blur',
                    },
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { validator: checkPhone, trigger: 'blur' },
                ],
                meetAt: [
                    { required: true, message: '请选择面试时间', trigger: 'blur' },
                ],
                meet_place: [
                    { required: true, message: '请选择面试地点', trigger: 'blur' },
                ],
                station: [
                    {
                        min: 1,
                        max: 20,
                        message: '长度在 1 到 20 个字符',
                        trigger: 'blur',
                    },
                ],
                feishuurl: [
                    {
                        min: 1,
                        max: 200,
                        message: '长度在 1 到 200 个字符',
                        trigger: 'blur',
                    },
                ],
            },
        }
    },
    watch: {
        dataTypeOrder: {
            immediate: true,
            handler(n, o) {
                this.npage = 1
                if (JSON.stringify(n) !== JSON.stringify(o) && JSON.stringify(n) !== '{}') this.loadTable()
            }
        }
    },
    methods: {
        openServiceTimeDrawer(data) {
            this.ServiceTimeDrawer = true
        },
        openUrl(url) {
            let newPage = this.$router.resolve({
                path: '/documentation',
                query: { url: url },
            })
            window.open(newPage.href, '_blank')
        },
        getAdminUser() {
            this.$axios.get('/api/admin/users').then((res) => {
                const { data } = res
                if (data.code === 0) {
                    this.options_adminUsers = data.data.users
                    this.roles = data.data.roles
                    this.statistical = data.data.statistical
                }
            })
        },
        getUser() {
            this.$axios.get('/api/admin/users').then((res) => {
                const { data } = res
                if (data.code === 0) {
                    this.users = data.data.users
                    this.roles = data.data.roles
                    this.branch = data.data.branch
                    this.statistical = data.data.statistical
                }
            })
        },
        copy(data) {
            // 存储传递过来的数据
            let OrderNumber = data
            // 创建一个input 元素
            // createElement() 方法通过指定名称创建一个元素
            let newInput = document.createElement('input')
            // 讲存储的数据赋值给input的value值
            newInput.value = OrderNumber
            // appendChild() 方法向节点添加最后一个子节点。
            document.body.appendChild(newInput)
            // 选中input元素中的文本
            // select() 方法用于选择该元素中的文本。
            newInput.select()
            // 执行浏览器复制命令
            //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
            document.execCommand('Copy')
            // 清空输入框
            newInput.remove()
            // 下面是element的弹窗 不需要的自行删除就好
            this.$message({
                message: '复制成功',
                type: 'success',
            })
        },
        copySome(data) {
            this.copy(data)
        },
        handleSizeChange_un(val) {
            // console.log(`每页 ${val} 条`)
            this.pageSize_un = val
            this.getUnMatterOveredData()
        },
        handleCurrentChange_un(val) {
            this.npage_un = val
            this.getUnMatterOveredData()
        },
        openCompanyCom(row) {
            this.companyInfoDrawer = true
            setTimeout(() => {
                this.companyComId = row.id
            })
        },
        openCompanyCom_examine(row) {
            this.companyInfoDrawer = true
            setTimeout(() => {
                this.companyComId = row.company_id
            })
        },
        closeUnMatterOveredDrawer() {
            this.unMatterOveredId = ''
            this.unMatterOveredData = []
        },
        getUnMatterOveredData() {
            if (!this.unMatterOveredId) return false
            this.$axios
                .get(
                    'api/service-time/get_matter_un?page' +
                    this.npage_un +
                    '&perPage=' +
                    this.pageSize_un +
                    '&cid=' +
                    this.unMatterOveredId
                )
                .then(({ data }) => {
                    if (data.code === 1) {
                        this.unMatterOveredData = data.data.data
                        this.total_un = data.data.total
                    }
                })
                .catch()
        },
        openUnMatterOvered(id) {
            this.unMatterOveredId = id
            this.getUnMatterOveredData()
            this.unMatterOveredDrawer = true
        },
        beforeAvatarUpload(file) {
            // const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
            const isLt100M = file.size / 1024 / 1024 < 100

            // if (!isJPG) {
            //   this.$message.error('上传图片格式为JPG或PNG!')
            //   return
            // }
            if (!isLt100M) {
                this.$message.error('上传总大小不能超过 100MB!')
                return false
            }
            // return isJPG && isLt2M
        },
        handleAvatarSuccess(res, file) {
            if (res.code === 1) {
                this.needUrl.push({ url: res.url, name: file.name, uid: file.uid })
            }
            // this.imageUrl = URL.createObjectURL(file.raw)
        },
        handleAvatarChange(res, file) {
            this.fileList = file
            this.change = true
        },
        handlePictureCardPreview(file) {
            this.fileNameList = file.name
        },
        handleRemove(file, fileList) {
            this.needUrl.map((item, index) => {
                if (item.uid === file.uid) {
                    this.needUrl.splice(index, 1)
                }
            })
            this.fileList = fileList
            this.change = true
        },
        // 监听粘贴操作
        handlePaste(event) {
            const items = (event.clipboardData || window.clipboardData).items
            let file = null
            if (!items || items.length === 0) {
                this.$message.error('当前浏览器不支持本地')
                return
            }
            // 搜索剪切板items
            for (let i = 0; i < items.length; i++) {
                // if (items[i].type.indexOf('image') !== -1) {
                file = items[i].getAsFile()
                // break
                // }
            }
            // if (!file) {
            //   this.$message.error('粘贴内容非图片')
            //   return
            // }
            if (this.fileList.length >= this.limit) {
                this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`) // 图片数量超出
                return
            }
            this.$refs.uploadMutiple.handleStart(file) // 将粘贴过来的图片加入预上传队列
            this.$refs.uploadMutiple.submit() // 提交图片上传队列
        },
        submitDisForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.distributeForm.file = this.needUrl
                    this.distributeForm.id = this.aboutExId
                    this.$axios
                        .post('api/service-time/store', this.distributeForm)
                        .then(({ data }) => {
                            if (data.code === 1) {
                                this.$message.success(data.msg)
                                this.distributeDrawer = false
                                this.$refs.distributeForm.resetFields()
                                this.fileList = []
                                this.needUrl = []
                                this.change = false
                                this.loadTable()
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                        .catch()
                } else {
                    return false
                }
            })
        },
        handleSizeChange_inside(val) {
            // console.log(`每页 ${val} 条`)
            this.pageSize_inside = val
            this.loadTable_inside()
        },
        handleCurrentChange_inside(val) {
            this.npage_inside = val
            this.loadTable_inside()
        },
        clearExamineParams() {
            let check = document.getElementsByTagName('input')
            let arr = Array.from(check)
            console.log(arr)
            arr.map((item) => {
                item.checked = false
            })
            // for (var i in this.examine) {
            //   this.examine[i] = false
            // }
            // this.examine.map((item, index) => {
            //   this.examine.splice(index, 1)
            // })
            this.examineId = ''
        },
        loadTable_inside() {
            this.$axios
                .get('api/service-time/' + this.examineId, {
                    params: {
                        page: this.npage_inside,
                        perpage: this.pageSize_inside,
                        // searchItem: this.searcher
                    },
                })
                .then(({ data }) => {
                    if (data.code === 1) {
                        this.examineData = data.data.data
                        this.total_inside = data.data.total
                        // this.loadRadio()
                        // this.loadSort()
                    }
                })
                .catch()
        },
        examineChange(val, id, index) {
            if (val) {
                this.$axios
                    .put('api/service-time/' + this.examineId, {
                        company_id: id,
                    })
                    .then(({ data }) => {
                        if (data.code === 1) {
                            // this.exmined.push(id)
                            // this.examineData[index].is_examined = true
                            this.loadTable_inside()
                            this.loadTable()
                            this.$message.success(data.msg)
                            //   this.examineData = data.data.data
                            //   this.total_inside = data.data.total
                            // this.loadRadio()
                            // this.loadSort()
                        }
                    })
                    .catch()
            }
        },
        openNameRow(id) {
            this.examineId = id
            this.loadTable_inside()
            this.examineDialog = true
        },
        loadTable() {
            this.categoryData = []
            this.$axios
                .get(`${this.hyperfHost}/v1/api/promotion/public/get_detail_reg`, {
                    params: {
                        page: this.npage,
                        perpage: this.categoryPerPage,
                        // searchItem: this.searchArr,
                        dataType: this.dataTypeOrder
                    },
                })
                .then(({ data }) => {
                    if (data.code === 200) {
                        this.categoryData = data.data.data
                        this.total = data.data.total
                    }
                })
                .catch()
        },
        loadRadio() {
            this.categoryData.map((item) => {
                if (item.display === 1) {
                    this.ListIfDisplay[item.id] = false
                } else {
                    this.ListIfDisplay[item.id] = true
                }
            })
        },
        loadSort() {
            this.categoryData.map((item) => {
                this.listSort[item.id] = Number(item.sort)
            })
        },
        handleCurrentChange(val) {
            this.npage = val
            this.loadTable()
        },
        handleSizeChange(val) {
            this.categoryPerPage = val
            this.loadTable()
        },
        editRow(id) {
            this.$axios
                .put('api/service-time/all_examined/' + id)
                .then(({ data }) => {
                    if (data.code === 1) {
                        this.$message.success(data.msg)
                        this.loadTable()
                    }
                })
                .catch()
        },
        searchRemoteCfcategory(query) {
            if (query !== '') {
                this.searchLoading = true
                setTimeout(() => {
                    this.searchLoading = false
                    this.searchItem(query)
                }, 200)
            } else {
                this.searchCategories = []
            }
        },
        searchItem(query) {
            this.$axios
                .get('api/recruit_manage_remote_search', {
                    params: {
                        search: query,
                    },
                })
                .then(({ data }) => {
                    if (data.code === 1) {
                        this.searchCategories = data.data
                    }
                })
                .catch()
        },
        handleSearchCfcategory(query) {
            this.searcher = query
            setTimeout(() => {
                this.loadTable()
            })
        },
        categoryIn() {
            this.categoryIndrawer = true
        },
        handleClose(done) {
            this.$refs.categoryForm.resetFields()
            this.$confirm('确认关闭？')
                .then((_) => {
                    done()
                })
                .catch((_) => { })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.categoryForm.file = this.needUrl
                    this.$axios
                        .post('api/recruit_manage_store', this.categoryForm)
                        .then((res) => {
                            const { data } = res
                            if (data.code === 1) {
                                this.$message.success(data.msg)
                                this.$refs.categoryForm.resetFields()
                                this.$bus.$emit('ysyclearrm')
                                this.categoryIndrawer = false
                                this.loadTable()
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                        .catch()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        editSubmitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$axios
                        .put('api/advicecate/edit', {
                            id: this.category,
                            category_name: this.editCategoryForm.categoryId,
                            display: this.ifDisplay === false ? 1 : 0,
                        })
                        .then((res) => {
                            const { data } = res
                            if (data.code === 1) {
                                this.$message.success(data.msg)
                                this.categoryEditDrawer = false
                                this.loadTable()
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                        .catch()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        editListRadio(row) {
            this.$axios
                .put('api/advicecate/listshow', {
                    id: row.id,
                    display: this.ListIfDisplay[row.id] === false ? 1 : 0,
                })
                .then((res) => {
                    const { data } = res
                    if (data.code === 1) {
                        this.$message.success(data.msg)
                        this.loadTable()
                    } else {
                        this.$message.error(data.msg)
                    }
                })
                .catch()
        },
        setSort(row) {
            if (isNaN(this.listSort[row.id])) {
                this.$message.error('排序值为数字！')
                return false
            }
            this.$axios
                .put('api/advicecate/setsort', {
                    id: row.id,
                    sort: this.listSort[row.id],
                })
                .then((res) => {
                    const { data } = res
                    if (data.code === 1) {
                        this.$message.success(data.msg)
                        this.loadTable()
                    } else {
                        this.$message.error(data.msg)
                    }
                })
                .catch()
        },
        handleCloseServiceTimeDrawer(done) {
            // this.$confirm('确认关闭？')
            //   .then((_) => {
            done()
            //   })
            //   .catch((_) => {})
        },
        openExamineFeed(id) {
            this.aboutExId = id
            this.$axios
                .get('api/service-time/' + id + '/edit')
                .then(({ data }) => {
                    if (data.code === 1) {
                        this.FOptions = data.data
                        let obj = data.data[0]
                        this.distributeForm.progress = obj ? obj.progress : 1
                    }
                })
                .catch()
            this.distributeDrawer = true
        },
    }
}
</script>

<style scoped>
.order-component {
    padding: 0 0.2rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/PromotionStatistics/Public/Components/OrderCompoent.vue